var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');

router.get('tag', index);
router.get('tag/:any', form);
